import MainTemplate from "./main-template";

export default MainTemplate;
